const ReportTable = ({ data, mergedKeys }) => {
  // Calculate totals
  const total = data.reduce(
    (acc, item) => {
      const parseNumber = (value) => parseFloat(value?.replace(/,/g, "")) || 0;
      acc.NETWR += parseNumber(item.NETWR);
      acc.ZRET += parseNumber(item.ZRET);
      acc.ZRVAT += parseNumber(item.ZRVAT);
      acc.ZBAMT += parseNumber(item.ZBAMT);
      acc.ZAVAT += parseNumber(item.ZAVAT);
      acc.ZBTAMT += parseNumber(item.ZBTAMT);
      acc.ZFAMT += parseNumber(item.ZFAMT);
      return acc;
    },
    {
      NETWR: 0,
      ZRET: 0,
      ZRVAT: 0,
      ZBAMT: 0,
      ZAVAT: 0,
      ZBTAMT: 0,
      ZFAMT: 0,
    }
  );

  return (
    <div className="mt-6">

      {/* Indication for Merged Invoices */}
      <div className="mb-4 flex justify-between items-center">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Invoice Report</h3>
        <p className="flex items-center text-gray-700 font-medium">
          <span
            className="w-4 h-4 inline-block mr-2 bg-green-100 border border-gray-300"
            aria-label="Merged Invoice Indicator"
          ></span>Merged Invoices.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300 rounded-md">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left">Invoice No</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Total Amount Before Tax</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Retention Amount</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Total VAT Amount After Retention</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Balance Amount Before Tax</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Tax On Advance</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Balance Tax Amount</th>
              <th className="border border-gray-300 px-4 py-2 text-right">Balance Amount After Tax</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                className={`${
                  mergedKeys?.includes(item.MATNR) ? "bg-green-100" : "bg-white"
                }`}
              >
                <td className="border border-gray-300 px-4 py-2">{item?.VBELN}</td>
                <td className="border border-gray-300 px-4 py-2">{item.NETWR}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZRET}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZRVAT}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZBAMT}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZAVAT}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZBTAMT}</td>
                <td className="border border-gray-300 px-4 py-2 text-right">{item.ZFAMT}</td>
              </tr>
            ))}
            <tr className="bg-gray-200 font-bold">
              <td className="border border-gray-300 px-4 py-2 text-left">Total</td>
              <td className="border border-gray-300 px-4 py-2">{total.NETWR.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZRET.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZRVAT.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZBAMT.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZAVAT.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZBTAMT.toFixed(2)}</td>
              <td className="border border-gray-300 px-4 py-2 text-right">{total.ZFAMT.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportTable;
